export default __webpack_public_path__ + "static/media/engineer.72d307d4.svg";